import { EUserRole } from '../../../../Domain/Enum/EUserRole';
import { EEntityType } from '../../../../Domain/Enum/EEntityType';
import { VolmaContainer } from '../../../../Infrastructure/InversifyInject';
import { Types } from '../../../../Infrastructure/Types';
import { VolmaModalActions } from '../../../VolmaModal/VolmaModalActions';
import { DeliveryTableActions } from '../Table/DeliveryTableActions';
import { IVolmaTableAction } from '../../../Table/VolmaTable/IVolmaTableProps';
import { DeliveryWithdrawDTO } from '../../../../Domain/DTO/DeliveryWithdrawDTO';
import i18next from '../../../i18n';
import { DeliveryWithdrawExtendedDTO } from '../ActionWithdraw/DeliveryWithdrawExtendedDTO';
import { DeliveryTableDTO } from '../../../../Domain/DTO/DeliveryTableDTO';
import { VolmaTableAction } from '../../../Table/VolmaTable/VolmaTableAction';
import { EDeliveryState } from '../../../../Domain/Enum/EDeliveryState';
import { DeliveryStateDTO } from '../../../../Domain/DTO/DeliveryStateDTO';
import PropertyHelper from '../../../../Infrastructure/Services/PropertyHelper';
import { TableDataDTO } from '../../../../Domain/TableDataDTO';

export class DeliveryRestartAssignationAction<THelper> extends VolmaTableAction<THelper>{
    private _modalActions: VolmaModalActions;
    private _deliveryTableActions: DeliveryTableActions;

    public Title: string = "delivery:RestartAssignation";
    
    public IsAvailable(selectedIds: Array<string>, data: Array<DeliveryTableDTO>) {
        if (this._authService.IsShipperExtended() || this._authService.IsAdministrator() ) {
            if (!PropertyHelper.IsArray(selectedIds) || selectedIds.length < 1)
                return false;
            for (let selectedId of selectedIds) {
                let itm = data.find(x => x.Id === selectedId);
                if (itm === undefined)
                    return false
                if (itm.State !== EDeliveryState.New &&
                    itm.State !== EDeliveryState.Revoked)
                    return false
            }
            return true;

        }
        return false;
    }
    
    public OnActivate(name: string, entity: EEntityType, selectedIds: Array<string>, data: Array<DeliveryTableDTO>, dispatch: any, reloadData: () => void) {
        let identifiers = new Array<string>();
        for (let selectedId of selectedIds) {
            let itm = data.find(x => x.Id === selectedId);
            if (itm !== undefined)
                identifiers.push(itm.Identifier);
        }        
        let text = i18next.t("delivery:RestartAssignationdDelivery", { count: identifiers.length, identifier: identifiers.join(', ') } as any)
        dispatch(this._modalActions.OpenConfirmationModal(text, () => {
            let tableDataDTO = new TableDataDTO<DeliveryStateDTO>();
            tableDataDTO.Items = new Array<DeliveryStateDTO>();
            tableDataDTO.Count = 0;
            for (let selectedId of selectedIds) {
                let stateDTO = new DeliveryStateDTO();
                stateDTO.DeliveryId = selectedId;
                stateDTO.CommentsForCargoTransporter = undefined;
                stateDTO.CommentsForShipper = undefined;
                stateDTO.DeliveryState = EDeliveryState.Revoked;
                tableDataDTO.Items.push(stateDTO);
                tableDataDTO.Count++;
            }

            dispatch(this._deliveryTableActions.DeliveryAddStates(tableDataDTO, i18next.t("common:Loading"), reloadData));            
        }))
    }

    constructor(){
        super();
        this._modalActions         = VolmaContainer.get<VolmaModalActions>(Types.VolmaModalActions);
        this._deliveryTableActions = VolmaContainer.get<DeliveryTableActions>(Types.DeliveryTableActions);
    }
}